export function htmlDecode(value) {
    const doc = new DOMParser().parseFromString(value, "text/html");
    return doc.documentElement.textContent;
}

export function htmlEncode(value) {
    return String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
}